import type { PlcManufacturerCodeLibrary } from "./types";

export const bosch_rexrothCodeLibrary: PlcManufacturerCodeLibrary = {
  manufacturer_id: "bosch-rexroth",
  manufacturer_name: "Bosch Rexroth",
  codes: [
    {
      id: "bosch-ctrlx-f0",
      manufacturer_id: "bosch-rexroth",
      series_id: "bosch-ctrlx-core",
      model: null,
      code: "F0",
      code_type: "Diagnostic Class",
      title_ar: "ctrlX CORE Non-critical Error",
      description_ar: "ضمن ctrlX diagnostic system، F0 مصنف كخطأ غير حرج؛ المثال الرسمي يشمل أخطاء configuration.",
      symptoms: ["ظهور تشخيص F0", "النظام ممكن يبقى متاح حسب الحالة"],
      causes: ["Configuration error أو خطأ غير حرج مشابه"],
      checks: [
        {
          step: 1,
          action: "افتح ctrlX diagnostics واقرأ الـmain/detail diagnostic بالكامل.",
          expected: "السبب التفصيلي واضح وماكو خطأ فعال بعد المعالجة.",
          faulty: "F0 يبقى Active.",
        }
      ],
      solutions: ["عالج الـconfiguration أو السبب التفصيلي المعروض.", "لا تعتمد على F0 وحده؛ اقرأ detail code."],
      severity: "تحذير",
      source_title: "Bosch Rexroth ctrlX AUTOMATION diagnostics",
      source_section: "Error detection and error reaction: F0 non-critical errors",
      keywords: ["Bosch Rexroth", "ctrlX CORE", "F0", "diagnostic"],
    },
    {
      id: "bosch-ctrlx-f8-f9",
      manufacturer_id: "bosch-rexroth",
      series_id: "bosch-ctrlx-core",
      model: null,
      code: "F8/F9",
      code_type: "System Error",
      title_ar: "ctrlX CORE Runtime System Error",
      description_ar: "F8 وF9 ضمن status display تشير إلى System Error بالـctrlX CORE Runtime ويظهر الـstatus باللون الأحمر.",
      symptoms: ["Status LED أحمر", "F8 أو F9"],
      causes: ["Runtime system error"],
      checks: [
        {
          step: 1,
          action: "اقرأ Main Diagnostics بالـctrlX CORE وسجل main/detail codes.",
          expected: "يظهر سبب تفصيلي قابل للتشخيص.",
          faulty: "F8/F9 بدون معالجة السبب التفصيلي.",
        }
      ],
      solutions: ["اتبع التشخيص التفصيلي للـmain/detail code.", "إذا الخطأ System-level مستمر بعد reboot المسموح، راجع دعم Rexroth."],
      severity: "حرجة",
      source_title: "Bosch Rexroth ctrlX CORE Status displays",
      source_section: "System error (F8 and F9) in ctrlX CORE Runtime",
      keywords: ["Bosch Rexroth", "ctrlX CORE", "F8", "F9", "system error"],
    },  ],
};
